import React, { useEffect } from "react";
import Body from "./components/Body";
import Header from "./components/Header";
import { ReactLenis } from "lenis/react";

const App = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            // Stop observing once visible to maintain state and prevent refades
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1, // Trigger when 10% of the element enters the viewport
        rootMargin: "0px 0px -50px 0px", // Trigger slightly before crossing the bottom threshold
      }
    );

    const animateElements = document.querySelectorAll(".scroll-fade, .reveal-up, .reveal-down");
    animateElements.forEach((el) => observer.observe(el));

    return () => {
      animateElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <ReactLenis root>
      <div className="max-w-screen-2xl w-full mx-auto px-4 overflow-x-hidden">
        <Header />
        <Body />
      </div>
    </ReactLenis>
  );
};

export default App;
